import React from "react";
import { Heading } from "web/react/emo/heading";
import { Modal } from "web/react/emo/modal";
import { VerifiedBadge } from "web/react/emo/verified-badge";
import { View } from "web/react/emo/view";
import * as styles from "./storefront-info-modal.css";
import { StorefrontInfo } from "./storefront-info/storefront-info";

interface StorefrontInfoModalProps {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    description?: string;
    dateAdded: string;
    isCheckout?: boolean;
    isOfficialStore?: boolean;
}

export function StorefrontInfoModal({
    title,
    isOpen,
    onClose,
    description,
    dateAdded,
    isCheckout = false,
    isOfficialStore = false,
}: StorefrontInfoModalProps): JSX.Element {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <View className={styles.container}>
                <View className={styles.titleSection} marginBottom="sm">
                    <Heading textStyle="subhead">{title}</Heading>
                    {isCheckout && <VerifiedBadge size="sm" />}
                </View>
                <View marginBottom="sm" className={styles.divider} />
                <View marginBottom="sm" className={styles.contentContainer}>
                    <StorefrontInfo
                        description={description}
                        dateAdded={dateAdded}
                        isCheckout={isCheckout}
                        isOfficialStore={isOfficialStore}
                    />
                </View>
            </View>
        </Modal>
    );
}
